import { render, staticRenderFns } from "./GalleryDetails.vue?vue&type=template&id=57087074"
import script from "./GalleryDetails.vue?vue&type=script&lang=js"
export * from "./GalleryDetails.vue?vue&type=script&lang=js"
import style0 from "./GalleryDetails.vue?vue&type=style&index=0&id=57087074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports